// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"Filters__modalContainer___nwTLb","modalBody":"Filters__modalBody___1FauB","title":"Filters__title___2dvX6","subtitle":"Filters__subtitle___rUrjn","dividerDouble":"Filters__dividerDouble___oIyxx","CTAContainer":"Filters__CTAContainer___1K6e6","filtersContainer":"Filters__filtersContainer___2EdMF"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/matches/components/Filters.scss
// module id = 1609
// module chunks = 0